import type { MonospaceOrgRole } from '#layers/data-model';
import { RStoreSchema } from '#imports';

export const OrgRole = RStoreSchema.withItemType<MonospaceOrgRole>().defineCollection({
	name: 'MonospaceOrgRole',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: ['id', 'name', 'isAdmin'],
		endpoint: 'system/roles',
	},
});
